import createSelector from 'web-app/util/custom-create-selector';
import {type RootState} from 'web-app/react/redux/root-state';
import {immutableSelectorCreator} from 'web-app/util/immutable';

export const dialogIDs = createSelector(
    (state: RootState) => state.dialog.dialogs,
    dialogs => dialogs.keySeq(),
);

export const makeDialogSelector = () => {
    return immutableSelectorCreator(
        (state: RootState, props) => props.id,
        (state: RootState) => state.dialog.dialogs,
        (id, dialogs) => dialogs.get(id)!,
    );
};
